import { Tag } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { FecJournalMappingStatus } from '../../../../../../enums/fecJournalMappingStatus'

const STATUS_TRANSLATION_KEYS: Record<FecJournalMappingStatus, string> = {
  [FecJournalMappingStatus.Standard]:
    'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.status.standard',
  [FecJournalMappingStatus.CustomJournal]:
    'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.status.custom_journal',
  [FecJournalMappingStatus.CustomLabel]:
    'settings.organization.accounting.fec_file_import.modal.mapping_step.journals.status.custom_label',
}

interface JournalStatusBadgeProps {
  status: FecJournalMappingStatus
}

export const JournalStatusBadge = ({ status }: JournalStatusBadgeProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Tag
      color={status === FecJournalMappingStatus.Standard ? 'neutral' : 'blue'}
      label={t(STATUS_TRANSLATION_KEYS[status])}
      size="small"
      type="subtle"
    />
  )
}
